import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
  whiteSpaceNormal: { whiteSpace: "normal" }
}));
